import React from 'react';

const InputNumber = ({ name, label, formError, value, onChange, className = "col-md-6" }) => {
    return (
        <div className={className}>
            <label className="form-label">{label}</label>
            <input
                type="number"
                className={`form-control ${formError && formError[name] && formError[name].length > 0 ? 'is-invalid' : ''}`}
                name={name}
                value={value || ''}
                onChange={onChange}
            />
            {formError?.[name] && (
                <div className="invalid-feedback">
                    {formError[name].join(', ')}
                </div>
            )}
        </div>
    );
};

export default React.memo(InputNumber);
